'use client';
import { Modal } from '@mantine/core';

import { useGetOrgQuery } from '@scaleup/frontend/api';
import { useSupplierStatusFlags, useUserPreference } from '@scaleup/frontend/hooks';
import { OrgTypes, Supplier } from '@scaleup/models';
import {
  SupplierIntakeContextProvider,
  useSupplierIntakeContext,
} from './context';
import { Demographics } from './demographics';
import { Details } from './details';
import { Industry } from './industry';
import { Init } from './init';
import { Naics } from './naics';
import { Structure } from './structure';
import { Review } from './review';
import { Final } from './final';

const InnerComponent = () => {
  const {
    flagLoading,
    currentStep,
    show,
    setShow,
    supplier,
  } = useSupplierIntakeContext();

  if (flagLoading || !supplier) {
    return null;
  }

  if (supplier.orgType !== OrgTypes.supplier) {
    return null;
  }

  if(supplier.statusFlags?.hasCompletedSupplierIntake) {
    return null;
  }

  const render = () => {
    switch (currentStep) {
      case 'init':
        return <Init />;
      case 'details':
        return <Details />;
      case 'demographics':
        return <Demographics />;
      case 'industry':
        return <Industry />;
      case 'structure':
        return <Structure />;
      case 'naics':
        return <Naics />;
      case 'review':
        return <Review />;
      case 'final':
        return <Final />;
      default:
        return 'TEST';
    }
  };

  return (
    <Modal
      classNames={{ body: 'bg-[#edf7fa] min-h-screen' }}
      fullScreen
      opened={show}
      closeOnEscape={false}
      closeOnClickOutside={false}
      withCloseButton={false}
      onClose={() => setShow(false)}
    >
      <div className="p-8 w-full">{render()}</div>
    </Modal>
  );
};

export const SupplierIntakeWizard = () => {
  const { supplier, flagLoading, ...prefs } = useSupplierStatusFlags(
    'hasCompletedSupplierIntake',
    false
  );

  if (flagLoading || !supplier) {
    console.log('loading or error or no user or no supplier');
    return null;
  }

  return (
    <SupplierIntakeContextProvider
      prefs={{ flagLoading, ...prefs }}
      supplier={supplier as Supplier}
    >
      <InnerComponent />
    </SupplierIntakeContextProvider>
  );
};
